<template>
  <div class="auth-page page-padding-top">
    <top-bar :title="$t('userAuth.title')"  @back="back"></top-bar>

    <div class="auth-main">
      <div class="flex-column-center status-box" v-if="isPending">
        <img :src="successUrl" alt="">
        <div  class="status">{{$t('userAuth.status2')}}</div>
        <div  class="desc">{{$t('userAuth.statusDesc2')}}</div>
      </div>
      <div class="flex-column-center status-box" v-else-if="isSuccess">
        <img :src="successUrl" alt="">
        <div  class="status">{{$t('userAuth.status1')}}</div>
        <div  class="desc">{{$t('userAuth.statusDesc1')}}</div>
      </div>
      <div class="auth-form" v-else-if="isEditable">
        <div class="form-item pad" @click="showCountry" v-show="step == 1">
          <div class="label">{{i18n.t('userAuth.label1')}}</div>
          <div class="input  flex-center-between" :class="form.countryName ? 'active' : ''">
            <span>{{form.countryName || i18n.t('userAuth.placeholder1')}}</span>
            <img :src="rightUrl" alt="">
          </div>
        </div>
        <div class="form-item pad" @click="changeType" v-show="step == 1">
          <div class="label">{{i18n.t('userAuth.label2')}}</div>
          <div class="input  flex-center-between" :class="form.cardTypeName ? 'active' : ''">
            <span>{{form.cardTypeName || i18n.t('userAuth.placeholder2')}}</span>
            <img :src="rightUrl" alt="">
          </div>
        </div>
        <div class="form-item" v-show="step == 1">
          <div class="label">{{i18n.t('userAuth.label10')}}</div>
          <div class="input">
            <input type="text" :placeholder="i18n.t('userAuth.placeholder5')" v-model="form.username">
          </div>
        </div>
        <div class="form-item" v-show="step == 1">
          <div class="label">{{i18n.t('userAuth.label3')}}</div>
          <div class="input">
            <input type="text" :placeholder="i18n.t('userAuth.placeholder3')" v-model="form.cardNo">
          </div>
        </div>

        <div class="form-item" v-show="step == 2">
          <div  class="file-box ">
            <div class="auth">
              <div class="bg flex-column-center" >
                <div class="text" :class="form.card1 ? 'active' : ''">
                  {{form.cardType == 1 ? i18n.t('userAuth.label5') : (form.cardType == 2 ?  i18n.t('userAuth.label6') :  i18n.t('userAuth.label11'))}}
                </div>
                <span v-if="form.card1" class="desc">{{i18n.t('userAuth.label9')}}</span>
                <img :src="localImages[1] || (form.card1 ? `/upload/tmp/${form.card1}` : (form.cardType == 1 ? cardUrl : cardUrl3))" alt="" @click.stop="chooseFile(1)">
                <Progress v-if="showProgress && fileType == 1" :percentage="uploadPercent" stroke-width="8" style="width: 80%; margin-top: 10px;" />
                <input type="file" class="hide-box" id="fileInput1" @change="changeFile($event, 1)" accept="image/*"> 
              </div>
            </div>

            <div class="auth" v-show="form.cardType == 1">
              <div class="bg  flex-column-center">
                <div class="text" :class="form.card2 ? 'active' : ''">
                  {{i18n.t('userAuth.label7')}}
                </div>
                <span v-if="form.card2" class="desc">{{i18n.t('userAuth.label9')}}</span>
                <img :src="localImages[2] || (form.card2 ? `/upload/tmp/${form.card2}` : cardUrl2)" alt="" @click.stop="chooseFile(2)">
                <Progress v-if="showProgress && fileType == 2" :percentage="uploadPercent" stroke-width="8" style="width: 80%; margin-top: 10px;" />
                <input type="file" class="hide-box" id="fileInput2" @change="changeFile($event, 2)" accept="image/*">
              </div>
            </div>
          </div>
        </div>

        <div class="auth-desc" v-show="step == 2">
          <div class="desc-title">{{i18n.t('userAuth.desc1')}}</div>
          <div class="info">{{i18n.t('userAuth.desc2')}}</div>
          <div class="info">{{i18n.t('userAuth.desc3')}}</div>
        </div>

        <div>
          <Button @click="submit" :class="btnDisabled ? 'gray' : ''">{{i18n.t(`userAuth.btn${step}`)}}</Button>
        </div>
      </div>
    </div>

    <Popup v-model:show="showPopup" position="bottom">
      <div class="country-list clear-top" >
				<!-- <div class="title flex-center-between">
          <icon name="arrow-left" size="20" color="#000" @click="cancel"></icon>
          <span>{{i18n.t('login.labelPlaceholder3')}}</span>
          <span></span>
        </div> -->
        <div class="search-list flex-center-between">
          <div class="flex-center">
            <img :src="searchUrl" alt="">
            <input type="text" v-model="keyword" :placeholder="i18n.t('register.labelPlaceholder7')" @input="searchCountry" @change="searchCountry">
          </div>
        </div>
        <div class="group-list login" v-for="(item, i) in countryList" :key="i">
          <div class="country-title" :id="item.id" v-if="item.id != 'common' && !keyword">{{item.title}}</div>
          <div class="country-title flex-center-start" v-if="item.id == 'common' && !keyword">
            <img :src="starUrl" alt="">
            {{$t('common.use')}}
          </div>
          <div class="list flex-center-start" :class="child.key == form.country ? 'active' : ''" v-for="(child, index) in item.children" :key="index" @click.stop="chooseCountry(child)">
            <div class="img-box flex-center">
              <img :src="child.icon" alt="">
              <span>{{getCountryName(child.title)}}</span>
            </div>
            <div>
              {{child.key}}
            </div>
          </div>
        </div>
        <div class="fast-link">
          <div class="link" v-for="(item, i) in linkList" :key="i" @click="toFastPage(item)">
            {{item}}
          </div>
        </div>
			</div>
    </Popup>

     <Popup v-model:show="showPicker" position="bottom">
        <Picker
          :columns="typeList"
          valueKey="text"
          show-toolbar
          :confirm-button-text="$t('common.ensure')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="chooseType"
          @cancel="cancel"
        ></Picker>
     </Popup>
  </div>
</template>
<script>
import topBar from '@/components/topBar'
import { checkAuth, uploadFile, userIdentity } from '@/api/setting'
import { Button, Popup, Icon, Picker, Progress } from 'vant'
import TokenWebView from '@consenlabs-fe/webview'
import heic2any from 'heic2any'
export default {
  components: {
    Button,
    Popup,
    topBar,
    Icon,
    Picker,
    Progress
  },
  data() {
    return {
      form: {
        username: '',
        cardNo: '',
        country: '+1',
        countryName: 'United States',
        card1: '',
        card2: '',
        cardType: '',
        cardTypeName: ''
      },
      typeList: [
        {
          value: '1',
          text: this.$t('userAuth.idCard')
        },
        {
          value: '2',
          text: this.$t('userAuth.passport')
        },
        {
          value: '3',
          text: this.$t('userAuth.drivingLicense')
        },
      ],
      step: 1,
      keyword: '',
      searchUrl: require('../../assets/imgs/icon-search.png'),
      starUrl: require('../../assets/imgs/icon-star.png'),
      backUrl:require('../../assets/imgs/icon-back.png'),
      rightUrl:require('../../assets/imgs/icon-arrow-down3.png'),
      cardUrl: require('../../assets/imgs/auth1.png'),
      cardUrl2: require('../../assets/imgs/auth2.png'),
      successUrl: require('../../assets/imgs/icon-success2.png'),
      cardUrl3: require('../../assets/imgs/auth3.png'),
      authStatus: '',
      showPopup: false,
      showPicker: false,
      fileType: '',
      countryList: [],
      linkList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V','W', 'Y', 'Z'],
      uploadPercent: 0,
      showProgress: false,
      uploading: false,
      localImages: {
        1: '',
        2: ''
      }
    }
  },
  computed: {
    countryListBak() {
      return this.$store.state.countryList
    },
    isEditable() {
      return String(this.authStatus) === '0'
    },
    isPending() {
      return String(this.authStatus) === '1'
    },
    isSuccess() {
      return String(this.authStatus) === '2'
    },
    btnDisabled() {
      if (this.step == 1) {
        return !this.form.countryName || !this.form.cardType || !this.form.cardNo || !this.form.username
      } else if (this.step == 2) {
        return false
      }
    }
  },
  mounted() {
    this.countryList = [].concat(this.countryListBak)
    this.init()
  },
  methods: {
    init() {
      checkAuth().then(res => {
        this.authStatus = res.data.status
        if (!this.isEditable) {
          this.step = 1
          this.showPopup = false
          this.showPicker = false
        }
      })
    },
    back() {
      this.$router.go(-1)
    },
    showCountry() {
      if (!this.isEditable) {
        return
      }
      this.showPopup = true
      try {
        if (TokenWebView && TokenWebView.isTokenEnv()) {
          TokenWebView.apis.navigator.setTitle(this.$t('login.labelPlaceholder3'))
        }
      } catch {

      }
    },
    changeType() {
      if (!this.isEditable) {
        return
      }
      this.showPicker = true
    },
    cancel() {
      this.showPopup = false
      this.showPicker = false
      try {
        if (TokenWebView && TokenWebView.isTokenEnv()) {
          TokenWebView.apis.navigator.setTitle(this.$t('pageTitle.userAuth'))
        }
      } catch {

      }
    },
    chooseType(item) {
      if (!this.isEditable) {
        return
      }
      this.form.cardType = item.value
      this.form.cardTypeName = item.text
      this.showPicker = false
    },
    chooseFile(type) {
      if (!this.isEditable) {
        return
      }
      if (this.uploading) {
        this.$toast.fail(this.i18n.t('common.uploading'))
        return
      }
      this.fileType = type
      const inputId = `fileInput${type}`
      document.getElementById(inputId).value = ''
      document.getElementById(inputId).click()
    },
    async changeFile(e, type) {
      if (!this.isEditable) return
      let file = e.target.files[0]
      if (!file) return
      
      // 确保 fileType 正确
      this.fileType = type

      if (file.name.toLowerCase().endsWith('.avif')) {
        this.$toast.fail(this.i18n.t('userAuth.imageFormatNotSupported', ['AVIF']))
        return
      }

      if (file.name.toLowerCase().endsWith('.dng')) {
        this.$toast.fail(this.i18n.t('userAuth.imageFormatNotSupported', ['DNG']))
        return
      }

      if (file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif')) {
        try {
          this.$toast.loading({
            message: 'Processing...',
            forbidClick: true,
            duration: 0
          })
          const blob = await heic2any({
            blob: file,
            toType: 'image/jpeg',
            quality: 0.8
          })
          const convertedBlob = Array.isArray(blob) ? blob[0] : blob
          file = new File([convertedBlob], file.name.replace(/\.heic$/i, '.jpg').replace(/\.heif$/i, '.jpg'), {
            type: 'image/jpeg'
          })
          this.$toast.clear()
        } catch (error) {
          this.$toast.clear()
          console.error('HEIC conversion failed', error)
          this.$toast.fail(this.i18n.t('userAuth.imageFormatNotSupported', ['HEIC']))
          return
        }
      }

      // Local preview
      this.localImages[type] = URL.createObjectURL(file)

      let form = new FormData()
      form.append('file', file)

      this.showProgress = true
      this.uploadPercent = 0
      this.uploading = true

      uploadFile(form, (progressEvent) => {
        this.uploadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      }).then(res => {
        this.showProgress = false
        this.uploading = false
        if (res.code == 0) {
          this.$toast.success(this.i18n.t('userAuth.success1'))
          this.form[`card${type}`] = res.data
        } else {
          this.$toast.fail(res.msg)
          this.localImages[type] = ''
        }
      }).catch(() => {
        this.showProgress = false
        this.uploading = false
        this.localImages[type] = ''
      })
    },
    submit() {
      if (!this.isEditable) {
        return
      }
      if (this.uploading) {
        this.$toast.fail(this.i18n.t('common.uploading'))
        return
      }
      if (this.btnDisabled) {
        return
      }
      if (this.step == 1) {
        this.step = 2
      } else if (this.step == 2) {
        let form = new FormData()
        form.append('RealName', this.form.username)
        form.append('Country', this.form.countryName)
        form.append('CardNo', this.form.cardNo)
        form.append('CardFront', this.form.card1)
        form.append('CardBack', this.form.card2)
        form.append('CardType', this.form.cardType)
        userIdentity(form).then(res => {
          if (res.code == 0) {
            this.$toast.success(this.i18n.t('userAuth.success2'))
            this.authStatus = 1
            this.step = 1
            this.showPopup = false
            this.showPicker = false
          } else {
            this.$toast.fail(res.msg)
          }
        })
      }

    },
    searchCountry() {
      if (this.keyword) {
        this.countryList = this.countryListBak.map(v => {
          let children = v.children.filter(val => {
            return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1  && v.id != 'common'
          })
          if (children.length > 0) {
            return {
              children: children
            }
          } else {
            return {
              children: []
            }
          }
        })
      } else {
        this.countryList = [].concat(this.countryListBak)
      }
    },
    toFastPage(key) {
      let dom = document.getElementById(key)
      let parentDom = document.querySelector('.country-list')
      if (dom && parentDom) {
        let domTop = dom.offsetTop
        parentDom.scrollTo({
          top: domTop - 124
        })
      }
    },
    chooseCountry(data) {
      if (!this.isEditable) {
        return
      }
      this.form.country = data.key
      this.form.countryName = this.getCountryName(data.title)
      this.showPopup = false
      this.keyword = ''
      try {
        if (TokenWebView && TokenWebView.isTokenEnv()) {
          TokenWebView.apis.navigator.setTitle(this.$t('pageTitle.userAuth'))
        }
      } catch {

      }
    },
    getCountryName(name) {
      let newName = ''
      newName = name.substring(0, name.indexOf('(') - 1)
      return newName
    }
  }
}
</script>
